"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var selectors_1 = require("../customer/selectors");
var constants_1 = require("./constants");
var profilePreferencesMap = reselect_1.createSelector(function (state) { return state.profilePreferences.byProfileId; }, function (preferences) { return preferences || {}; });
exports.getPreferences = reselect_1.createSelector(profilePreferencesMap, selectors_1.selectedProfileId, function (preferencesMap, profileId) {
    return (preferencesMap === null || preferencesMap === void 0 ? void 0 : preferencesMap[profileId || 'default']) || {};
});
exports.getPreference = function (key) {
    return reselect_1.createSelector(exports.getPreferences, function (preferences) { return preferences[key]; });
};
exports.selectedCategoryId = reselect_1.createSelector(exports.getPreferences, function (preferences) { return preferences.selectedCategoryId; });
//# sourceMappingURL=selectors.js.map